import io from "socket.io-client";


class SocketWorker {
  constructor(companyId , userId) {
    const rawToken = localStorage.getItem("token");
    const sessionToken = rawToken ? `Bearer ${JSON.parse(rawToken)}` : undefined;

    if (!SocketWorker.instance) {
      this.companyId = companyId
      this.userId = userId
      this.token = sessionToken
      this.socket = null;
      this.configureSocket();
      this.eventListeners = {};
      this.connectionCallbacks = {};
      SocketWorker.instance = this;

    } 

    return SocketWorker.instance;
  }

  configureSocket() {
    this.socket = io(`${process.env.REACT_APP_BACKEND_URL}/${this?.companyId}` , {
      autoConnect: true,
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: Infinity,
      transports: ["websocket", "polling"],
      // pingTimeout: 18000,
      // pingInterval: 18000,
      query: { userId: this.userId, token: this.token }
    });

    this.socket.on("connect", () => {
      console.log("Conectado ao servidor Socket.IO");
      this._notifyConnectionCallbacks("connected");
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Desconectado do servidor Socket.IO:", reason);
      this._notifyConnectionCallbacks("disconnected", reason);
    });

    this.socket.on("connect_error", (error) => {
      console.error("Erro de conexão Socket.IO:", error.message);
      this._notifyConnectionCallbacks("error", error);
    });

    this.socket.on("reconnect_attempt", (attemptNumber) => {
      console.log(`Tentativa de reconexão #${attemptNumber}`);
      this._notifyConnectionCallbacks("reconnecting", attemptNumber);
    });

    this.socket.on("reconnect", (attemptNumber) => {
      console.log(`Reconectado após ${attemptNumber} tentativas`);
      this._notifyConnectionCallbacks("connected");
    });

    this.socket.on("reconnect_error", (error) => {
      console.error("Erro durante reconexão:", error.message);
      this._notifyConnectionCallbacks("reconnect_error", error);
    });

    this.socket.on("reconnect_failed", () => {
      console.error("Todas as tentativas de reconexão falharam");
      this._notifyConnectionCallbacks("reconnect_failed");
    });
  }

  // Adiciona um ouvinte de eventos
  on(event, callback) {

    this.connect();
    this.socket.on(event, callback);

    // Armazena o ouvinte no objeto de ouvintes
    if (!this.eventListeners[event]) {
      this.eventListeners[event] = [];
    }
    this.eventListeners[event].push(callback);
  }

  // Emite um evento
  emit(event, data) {
    this.connect();
    this.socket.emit(event, data);
  }

  // Desconecta um ou mais ouvintes de eventos
  off(event, callback) {
    // console.log(event, callback)
    this.connect();
    if (this.eventListeners[event]) {
      // console.log("Desconectando do servidor Socket.IO:", event, callback);
      if (callback) {
        // Desconecta um ouvinte específico
        this.socket.off(event, callback);
        this.eventListeners[event] = this.eventListeners[event].filter(cb => cb !== callback);
      } else {
        // console.log("DELETOU EVENTOS DO SOCKET:", this.eventListeners[event]);

        // Desconecta todos os ouvintes do evento
        this.eventListeners[event].forEach(cb => this.socket.off(event, cb));
        delete this.eventListeners[event];
      }
      // console.log("EVENTOS DO SOCKET:", this.eventListeners);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null
      SocketWorker.instance = null
      console.log("Socket desconectado manualmente");
    }
  }

  reconnectAfterDelay() {
    setTimeout(() => {
      if (!this.socket || !this.socket.connected) {
        console.log("Tentando reconectar após desconexão");
        this.connect();
      }
    }, 1000);
  }

  connect() {
    if (!this.socket) {
      this.configureSocket();
    }
  }

  forceReconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket.connect();
    }
  }

  onConnectionEvent(event, callback) {
    if (!this.connectionCallbacks[event]) {
      this.connectionCallbacks[event] = [];
    }
    this.connectionCallbacks[event].push(callback);

    if (event === "connected" && this.socket && this.socket.connected) {
      callback();
    }
  }

  offConnectionEvent(event, callback) {
    if (this.connectionCallbacks[event]) {
      if (callback) {
        this.connectionCallbacks[event] = this.connectionCallbacks[event].filter(
          (cb) => cb !== callback
        );
      } else {
        delete this.connectionCallbacks[event];
      }
    }
  }

  _notifyConnectionCallbacks(event, data) {
    if (this.connectionCallbacks[event]) {
      this.connectionCallbacks[event].forEach((cb) => cb(data));
    }
  }
}

// const instance = (companyId, userId) => new SocketWorker(companyId,userId);
const instance = (companyId, userId) => new SocketWorker(companyId, userId);

export default instance;